// Mobile presentation of the existing desktop homepage mega-menu destinations.
// Keep target URLs aligned with FeaturesDropdown, SolutionDropdown,
// LearningDropdown and CompanyDropdown when their destinations change.
export const homeMobileMenus = {
  features: [
    {
      title: "Explore features",
      items: [
        {
          title: "Real-Time Sales Tracking",
          description: "Sales, stock movement and updates.",
          path: "/features/realtime_sales_tracking",
        },
        {
          title: "Mobile App",
          description: "Your inventory while you're away.",
          path: "/features/mobile_application",
        },
        {
          title: "Inventory Photos",
          description: "Keep your product images organized.",
          path: "/features/inventory_photos",
        },
        {
          title: "Smart Alerts",
          description: "Stock, expiry and activity notifications.",
          path: "/features/alerts",
        },
        {
          title: "QR & Barcoding",
          description: "Faster item identification and scanning.",
          path: "/features/qr_barcoding",
        },
        {
          title: "Reporting & Analytics",
          description: "Business reports and insights.",
          path: "/features/reporting-analytics",
        },
        {
          title: "All features",
          description: "Explore the complete feature overview.",
          path: "/company/features",
        },
      ],
    },
  ],
  solutions: [
    {
      title: "Solutions",
      items: [
        {
          title: "Inventory Management",
          description: "Organize, manage and track stock.",
          path: "/solutions/inventory_management",
        },
        {
          title: "Supplies Tracking",
          description: "Keep operational supplies in view.",
          path: "/solutions/supplies_tracking",
        },
        {
          title: "Asset Tracking",
          description: "Monitor tools and valuable assets.",
          path: "/solutions/asset_tracking",
        },
      ],
    },
    {
      title: "Industries",
      items: [
        {
          title: "Pharmacy & Chemist",
          description: "Health retail and medical supplies.",
          path: "/solutions/industries/healthcare/pharmacy_chemist",
        },
        {
          title: "Wholesale & Distribution",
          description: "Optimize fulfillment and stock.",
          path: "/solutions/industries/wholesale_distribution",
        },
        {
          title: "Provision Store",
          description: "Everyday retail management.",
          path: "/solutions/industries/provision_store",
        },
        {
          title: "Electronics Store",
          description: "Manage devices and electronic stock.",
          path: "/solutions/industries/electronics",
        },
        // { title: "Furnitures", description: "Track products across locations.", path: "/solutions/industries/furnitures" },
        {
          title: "Building Materials",
          description: "Construction inventory and supplies.",
          path: "/solutions/industries/construction/building_materials",
        },
        // { title: "All industries", description: "Browse industry solutions.", path: "/solutions/industries" },
        // { title: "All solutions", description: "See the full solutions directory.", path: "/solutions/all-solutions" },
      ],
    },
  ],
  learn: [
    {
      title: "Learning topics",
      items: [
        {
          title: "Getting Started",
          description: "Set up your business workspace.",
          path: "/learning/getting_started",
        },
        {
          title: "Inventory Basics",
          description: "Items, categories, suppliers and stock.",
          path: "/learning/inventory_basics",
        },
        {
          title: "POS System Guide",
          description: "Checkout and daily POS workflows.",
          path: "/learning/pos_system",
        },
        {
          title: "Mobile Scanning",
          description: "Scan barcodes with your phone.",
          path: "/learning/mobile_scanning",
        },
        {
          title: "Stock Management",
          description: "Stay ahead of low stock.",
          path: "/learning/stock_management",
        },
        {
          title: "Sales & Reports",
          description: "Understand your performance.",
          path: "/learning/sales_reports",
        },
        {
          title: "Staff Management",
          description: "Manage staff access and roles.",
          path: "/learning/staff_management",
        },
        {
          title: "Multi-Branch System",
          description: "Manage multiple locations.",
          path: "/learning/multi_branch",
        },
        {
          title: "Mobile App Usage",
          description: "Make the most of the mobile app.",
          path: "/learning/mobile_app",
        },
        {
          title: "Real-Time Notifications",
          description: "Follow changes and alerts.",
          path: "/learning/notifications",
        },
      ],
    },
  ],
  company: [
    {
      title: "Universe Tech Industry",
      items: [
        {
          title: "About Us",
          description: "Who we are and what we build.",
          path: "/about-us",
        },
        {
          title: "Careers",
          description: "Opportunities to grow with us.",
          path: "/careers",
        },
        {
          title: "Affiliates",
          description: "Partnership and referral programs.",
          path: "/company/affiliates",
        },
        {
          title: "Partners",
          description: "Technology and business partners.",
          path: "/company/partners",
        },
        {
          title: "Security",
          description: "Our approach to protecting data.",
          path: "/company/security",
        },
        {
          title: "API & Developers",
          description: "Integration information.",
          path: "/company/developers",
        },
        {
          title: "Contact Support",
          description: "Get help and contact our team.",
          path: "/company/support",
        },
        {
          title: "Blog & Updates",
          description: "News, tips and product updates.",
          path: "/company/blog",
        },
      ],
    },
  ],
};
